//doughnut2d
import React, { useState, useEffect, useRef } from 'react';
import { Doughnut } from 'react-chartjs-2';
import 'chartjs-adapter-moment';
const DashboardCost = () => {
  const [data, setData] = useState([]);
  const [scope, setScope] = useState('');

  useEffect(() => {
    try {
      const getFacture = async () => {
        const response = await fetch('https://fusionsmart.seifeddineslimene.com/api/facture', {
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
          },
        });
        const data = await response.json();
        setData(data);
      };
      getFacture();
    } catch (error) {
      console.error(error);
    }
  }, []);

  const chartData = {
    labels: [ 'Electricity', 'Gas'],
    datasets: [
      {
        label: 'Electricity',
        data: data.map((entry) => entry?.montantElectricity?.split('$')[0]),
        backgroundColor: '#58E2C2',
      },
      {
        label: 'Gas',
        data: data.map((entry) => entry?.montantGaz?.split('$')[0]),
        backgroundColor: '#F7E53B',
      },
    ],
  };

  return (
    <div
      id='content-body'
      className='col-12 col-md-9 col-xl-10 pl-4 pr-4 bd-content'
    >
      <div>{data.length > 0 && <Doughnut data={chartData} />}</div>
    </div>
  );
};

export default DashboardCost;

/*
import moment from 'moment';
 // eslint-disable-next-line

 // var monthVal = moment().format('MMMM YYYY');

var first_chart_month = {
  chart: {
    showBorder: "0",
    showShadow: "0",
    use3DLighting: "0",
    showLabels: "0",
    showValues: "0",
    paletteColors: "#58E2C2, #F7E53B",
    bgColor: "#1D1B41",
    bgAlpha: "0",
    canvasBgAlpha: "0",
    doughnutRadius: "75",
    pieRadius: "95",
    // "pieRadius": "100",
    numberPrefix: "$",
    plotBorderAlpha: "0",
    toolTipBgcolor: "#484E69",
    toolTipPadding: "7",
    toolTipBorderRadius: "3",
    toolTipBorderAlpha: "30",
    tooltipBorderThickness: "0.7",
    toolTipColor: "#FDFDFD",
    baseFont: "Nunito Sans",
    baseFontSize: "14",
    baseFontColor: "#FDFDFD",
    showLegend: "1",
    legendShadow: "0",
    legendBorderAlpha: "0",
    drawCustomLegendIcon: "1",
    legendBgAlpha: "0",
    chartTopMargin: "-10",
    canvasTopMargin: "-10",
    chartBottomMargin: "20",
    canvasBottomMargin: "20",
    legendNumColumns: "1",
    legendPosition: "RIGHT",
    defaultCenterLabel: "Total <br> $214",
    centerLabel: "$label<br>$value",
    centerLabelBold: "1",
    centerLabelFontSize: "20",
    enableRotation: "0",
    transposeAnimation: "1",
    plotToolText: "<div>$label<br>$dataValue ($percentValue)<div>"
  },

  // "annotations": {
  //   "groups": [{
  //     "autoscale":"1",
  //     "items": [{
  //       "id": "1",
  //       "type": "text",
  //       "text": monthVal,
  //       "align": "left",
  //       "font": "Nunito Sans",
  //       "bold": "0",
  //       "fontSize": "14",
  //       "color": "#FDFDFD",
  //       "x": "$chartStartX + 15",
  //       "y": "$chartEndY - 20"
  //     }]
  //   }]
  // },

  data: [
    {
      label: "Electricity",
      value: "139"
    },
    {
      label: "Gas",
      value: "75"
    }
  ]
};

  //var yearVal = moment().format('YYYY');

var chartConfigs1 = {
    type: "doughnut2d",
    className: "fc-doughnut2d", 
    dataFormat: "JSON",
    width: "100%",
    height:"300",
    id: "mychart1",
    dataSource: first_chart_month
};

export default chartConfigs1;
export { first_chart_month };
*/
